import { apiSlice } from './apiSlice';

export const nodesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Query to get user's personal nodes
    getMyNodes: builder.query({
      query: () => '/nodes/my-nodes',
      providesTags: ['UserNodes'],
    }),
    
    // Mutation to add a node to user's list
    addMyNode: builder.mutation({
      query: (nodeId) => ({
        url: '/nodes/add-node',
        method: 'POST',
        body: { nodeId },
      }),
      invalidatesTags: ['UserNodes'],
    }),
    
    // Mutation to remove a node from user's list
    removeMyNode: builder.mutation({
      query: (nodeId) => ({
        url: '/nodes/remove-node',
        method: 'POST',
        body: { nodeId },
      }),
      invalidatesTags: ['UserNodes'],
    }),
  }),
});

export const {
  useGetMyNodesQuery,
  useAddMyNodeMutation,
  useRemoveMyNodeMutation,
} = nodesApi;

